"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ElementGenerator = void 0;
var countries_const_1 = require("./const/countries.const");
var translation_1 = __importDefault(require("./translation"));
var ElementGenerator = /** @class */ (function () {
    function ElementGenerator() {
        this.theme = {
            success: {
                background: '#a7f8a8',
                color: '#333',
            },
            info: {
                background: 'rgb(158, 196, 255)',
                color: '#333',
            },
            error: {
                background: '#ffdcd7',
                color: '#333',
            },
            transparent: {
                color: '#333',
            },
        };
        this.stylesAdded = false;
        // const searchInput = $('<input>')
        //   .attr('placeholder', 'Search country...')
        //   .addClass('search-input');
        // const selectElem = $('<select>').addClass('country-dropdown');
        // appendTo.append(searchInput).append(selectElem);
        // // Event listener for search functionality
        // searchInput.on('keyup', function () {
        //   const searchTerm = $(this).val()?.toString().toLowerCase();
        //   $('option', selectElem).each(function () {
        //     const text = $(this).text().toLowerCase();
        //     if (text.includes(searchTerm!)) {
        //       $(this).show();
        //     } else {
        //       $(this).hide();
        //     }
        //   });
        //   // Show the dropdown
        //   selectElem.show();
        // });
    }
    /**
     *
     * @param obj generator {html:text,css:obj,class:string}
     * @param type 'success' | 'error' | 'info' | 'transparent'
     * @param attr custom attributes {data-get:12345}
     * @returns
     */
    ElementGenerator.prototype.getRow = function (obj, type, attr) {
        var _a;
        if (attr === void 0) { attr = {}; }
        var theme = {};
        if (type === null || type === void 0 ? void 0 : type.length) {
            theme = __assign({ padding: '15px', margin: '20px 0px', borderRadius: '5px' }, this.theme[type]);
        }
        return $('<div>' + ((_a = obj === null || obj === void 0 ? void 0 : obj.html) !== null && _a !== void 0 ? _a : '') + '</div>')
            .addClass('m-row' + ((obj === null || obj === void 0 ? void 0 : obj.class) ? ' ' + obj.class : ''))
            .attr(attr)
            .css(__assign(__assign({ width: '100%', display: 'flex', alignItems: 'center' }, theme), obj === null || obj === void 0 ? void 0 : obj.css));
    };
    ElementGenerator.prototype.getCol = function (colSize, obj) {
        var _a;
        return $('<div>' + ((_a = obj === null || obj === void 0 ? void 0 : obj.html) !== null && _a !== void 0 ? _a : '') + '</div>')
            .addClass('m-col-' + colSize)
            .css(__assign({ width: 'calc(100% / ' + colSize + ')' }, obj === null || obj === void 0 ? void 0 : obj.css));
    };
    ElementGenerator.prototype.getDividerLine = function () {
        return $('<div></div>').addClass('divider-line margin');
    };
    ElementGenerator.prototype.getGeneric = function (obj) {
        var _a;
        return $('<div>' + ((_a = obj === null || obj === void 0 ? void 0 : obj.html) !== null && _a !== void 0 ? _a : '') + '</div>')
            .addClass((obj === null || obj === void 0 ? void 0 : obj.class) || '')
            .css(__assign({}, obj === null || obj === void 0 ? void 0 : obj.css));
    };
    ElementGenerator.prototype.twoColSetup = function (leftSide, rightSide, css) {
        var row = this.getRow();
        row.append(this.getCol(2, { html: leftSide, css: css }));
        row.append(this.getCol(2, {
            html: rightSide,
            css: __assign({ textAlign: 'right' }, css),
        }));
        return row;
    };
    ElementGenerator.prototype.createElements = function () {
        this.getPhonePrefixDropdown();
        this.getCountryDropdown();
    };
    ElementGenerator.prototype.getPhonePrefixDropdown = function () {
        return this.createDropdown('phone', function (country) {
            localStorage.setItem('phonePrefix', country.prefix);
            localStorage.setItem('customer.phonePrefix', country.prefix);
        });
    };
    ElementGenerator.prototype.getCountryDropdown = function () {
        return this.createDropdown('country', function (country) {
            localStorage.setItem('countryCode', country.isoCode);
            localStorage.setItem('customer.countryCode', country.isoCode);
        });
    };
    ElementGenerator.prototype.createDropdown = function (type, callback) {
        if (callback === void 0) { callback = function (country) { }; }
        var typeMapping = { phone: 'prefix', country: 'isoCode' };
        var dropdownContainer = $("#".concat(type, "-container"));
        if (dropdownContainer === null || dropdownContainer === void 0 ? void 0 : dropdownContainer.length) {
            this.addDropdownStyles();
            var dropdownButton_1 = dropdownContainer.find('.w-button');
            if (dropdownButton_1 === null || dropdownButton_1 === void 0 ? void 0 : dropdownButton_1.length) {
                var entryFieldsContainer_1 = $('<div>').addClass('dropdown-entry-container');
                entryFieldsContainer_1.hide();
                var searchField = $('<input>')
                    .addClass('search-field')
                    .attr('placeholder', 'Suche...');
                searchField.on('keyup', function (event) {
                    var _a;
                    var searchText = ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a['value']) || '';
                    generateSelection_1((searchText === null || searchText === void 0 ? void 0 : searchText.length) ? searchText : undefined);
                });
                var dropdownEntries = $('<div></div>').addClass('dropdown-entries');
                var searchFieldContainer_1 = $('<div>')
                    .addClass('dropdown-entry')
                    .css('padding', '0px')
                    .css('min-width', '300px');
                searchFieldContainer_1.append(searchField);
                searchFieldContainer_1.hide();
                dropdownEntries.append(searchFieldContainer_1);
                dropdownButton_1.on('click', function () {
                    entryFieldsContainer_1.toggle();
                    searchFieldContainer_1.toggle();
                });
                var generateSelection_1 = function (searchText) {
                    entryFieldsContainer_1.html('');
                    countries_const_1._COUNTRIES.forEach(function (country) {
                        var bracketValue = country[typeMapping[type]];
                        var countryElement = $('<div>')
                            .addClass('dropdown-entry')
                            .text("".concat(translation_1.default.t(country.name), " (").concat(bracketValue, ")"))
                            .on('click', function () {
                            entryFieldsContainer_1.toggle();
                            searchFieldContainer_1.toggle();
                            dropdownButton_1.html("".concat(bracketValue));
                            if (callback) {
                                callback(country);
                            }
                        });
                        if (searchText === null || searchText === void 0 ? void 0 : searchText.length) {
                            if (translation_1.default
                                .t(country.name)
                                .toLowerCase()
                                .includes(searchText.toLowerCase())) {
                                countryElement.appendTo(entryFieldsContainer_1);
                            }
                        }
                        else {
                            countryElement.appendTo(entryFieldsContainer_1);
                        }
                    });
                };
                generateSelection_1();
                dropdownEntries.append(entryFieldsContainer_1);
                dropdownContainer.append(dropdownEntries);
            }
            else {
                console.error("no button in ".concat(type, " container found"));
            }
        }
        else {
            console.error("no #".concat(type, "-container found"));
        }
    };
    ElementGenerator.prototype.addDropdownStyles = function () {
        if (this.stylesAdded === false) {
            $('<style>')
                .prop('type', 'text/css')
                .html("\n.dropdown-entry-container{\nmax-height: 300px;\noverflow-y: auto;\n}\n.dropdown-entries{\nz-index: 99999;\nposition: absolute;\nbox-shadow: 0px 4px 3px #aaa;\nmin-width:300px;\n}\n.dropdown-entry{\n  height:40px;\n  background:#eee;\n  width:100%;\n  display:flex;\n  align-items: center;\n  cursor:pointer; \n  padding: 0px 10px;\n}\n.dropdown-entry:hover{\n  background:#ddd;\n}\n.search-field{\n  width:100%;\n  padding:5px;\n}\n")
                .appendTo('head');
            this.stylesAdded = true;
        }
    };
    return ElementGenerator;
}());
exports.ElementGenerator = ElementGenerator;
